import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getApiErrorMessage } from '@/services/fetcher';
import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';

import { deletePricing } from '../data-provider';
import { CACHE_KEYS } from '../types';

export const useDeletePricing = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (keys: string[]) => deletePricing(keys),
    onError: async (error) => {
      const message = await getApiErrorMessage(error);

      showNotification({
        message: message ?? 'Failed to delete pricing from the contract. Please, try again',
        type: NOTIFICATION_TYPES.ERROR,
      });
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: CACHE_KEYS.all }),
    onSuccess: () => {
      showNotification({
        message: 'Successfully deleted the pricing',
        type: NOTIFICATION_TYPES.SUCCESS,
      });
    },
  });
};
